export interface Principle {
  title: string;
  text: string;
  icon: string;
}

export const principles: Principle[] = [
  {
    title: "可溯源",
    text: "每条结论都标注信源与时间点，传闻与事实严格区分，不把猜测包装成定论。",
    icon: "ri-links-line",
  },
  {
    title: "反网暴",
    text: "聚焦事件规律而非私生活窥探，拒绝人肉搜索与情绪化网暴，做清醒的观察者。",
    icon: "ri-heart-3-line",
  },
  {
    title: "中立呈现",
    text: "把当事人、公司、粉丝与平台的多方说法摆上同一张时间线，把判断权交还读者。",
    icon: "ri-scales-3-line",
  },
  {
    title: "持续补全",
    text: "热点过后不抛弃旧样本，不断回溯补全时间线与案例库，让吃瓜具备“复盘”价值。",
    icon: "ri-history-line",
  },
];

export interface TimelineMilestone {
  time: string;
  title: string;
  text: string;
}

export const milestones: TimelineMilestone[] = [
  {
    time: "2024",
    title: "从一张时间线表开始",
    text: "发现热点常被断章取义，我们决定把同类事件按日期和证据链整理成“时间线”，第一期只写了 3 个瓜，却收获了一群希望“把瓜吃明白”的读者。",
  },
  {
    time: "2025",
    title: "上线同类盘点栏目",
    text: "随着案例库积累，我们推出“同类盘点”，把散落多年的相似剧情归拢对比，逐渐形成行业观察向的独有内容形态。",
  },
  {
    time: "2026",
    title: "对比分析手册与实时热榜",
    text: "上线“对比分析”与“实时热榜”，从单点追更升级为纵向时间线 + 横向对比的双维覆盖，让相似剧情的后续走向也能一次摸清。",
  },
];